/**
 * FeatureCard - Container component for feature cards
 * 
 * This is the Container layer that handles logic, hooks, and state.
 * Delegates UI rendering to FeatureCardView.
 */
import useHoverEffect from '../../shared/hooks/useHoverEffect';
import FeatureCardView from './FeatureCardView';
import type { FeatureCardData } from './home.schema';

interface FeatureCardProps extends FeatureCardData {}

function FeatureCard({ title, description, icon, color }: FeatureCardProps) {

  // Use shared hover effect hook for consistent animation
  const { onMouseEnter, onMouseLeave } = useHoverEffect(
    'translateY(-5px)',
    'translateY(0px)'
  );

  // Handle keyboard interaction for accessibility
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      // Handle card activation - could navigate to details page or show modal
      console.log(`Feature card "${title}" activated via keyboard`);
    }
  };

  // Handle click interaction
  const handleClick = () => {
    console.log(`Feature card "${title}" clicked`);
    // Add click handling logic here - could navigate to detailed page
    try {
      // Future: Navigate to feature details or show modal
      // navigate(`/features/${title.toLowerCase().replace(/\s+/g, '-')}`);
    } catch (error) {
      console.error(`Error navigating to feature "${title}":`, error);
    }
  };

return (
    <FeatureCardView
      title={title}
      description={description}
      icon={icon}
      color={color}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onKeyDown={handleKeyDown}
      onClick={handleClick}
    />
  );
}

export default FeatureCard;